import { ChangePasswordFormComponent } from '../../../../forms/dynamic-forms/change-password-form/change-password-form.component';
import { EditEmailFormComponent } from '../../../../forms/dynamic-forms/profile-settings-forms/edit-email-form/edit-email-form.component';
import { CreateNewPasswordSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/create-new-password-svg/create-new-password-svg.component';
import { EmailValidateSVGComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/email-validate-svg/email-validate-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { User } from '@mapfre-design-library/src/public_api';
import { EditPasswordService } from '../../../../../_services/forms/profile-settings/edit-password.service';
import { EditEmailService } from '../../../../../_services/forms/profile-settings/edit-email.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, EmailValidateSVGComponent, CreateNewPasswordSvgComponent, EditEmailFormComponent, ChangePasswordFormComponent],
  selector: 'app-profile-edit-email',
  templateUrl: './profile-edit-email.component.html',
  providers: [EditPasswordService],
})
export class ProfileEditEmailComponent implements OnInit {
  verifyPassword: any[];
  user: User = {};
  whereInTheProcess: string;

  constructor(
    public activatedRoute: ActivatedRoute,
    private editPasswordService: EditPasswordService,
    private editEmailService: EditEmailService
  ) {}

  ngOnInit() {
    this.whereInTheProcess = this.activatedRoute.snapshot.routeConfig.path;
    if (this.whereInTheProcess === 'edit-email') {
      this.verifyPassword = this.editEmailService.getInputs('changeEmail');
    } else {
      this.verifyPassword =
        this.editPasswordService.getInputs('changePassword');
    }
  }

}
